import * as ReactDropdown from '@radix-ui/react-dropdown-menu'
import React from 'react'

export interface ManualDropdownTriggerProps {
  children: React.ReactElement
}
export function ManualDropdownTrigger({ children }: ManualDropdownTriggerProps) {
  return <ReactDropdown.Trigger asChild children={children} />
}
